import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { watch } from 'vue';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import authModule from '@/store/modules/auth';
import {
  AlertingHookService, AlertingHookDto, UserUiDto, UserService,
} from '@/api';
import i18n from '@/i18n';

interface Emit {
  (event: 'input', value: AlertingHookDto[]): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Mail-Tag-Selector',
  props: {
  value: null
},
  emits: ["input"],
  setup(__props, { emit }) {



const auth = getModule(authModule, store);

const { value: selectedMails } = __MACROS_useVModel(["value", undefined, "input"]);

let loading = _ref(false);
let mails = _ref<AlertingHookDto[]>([]);
const searchString = _ref('');

let users = _ref<UserUiDto[]>([]);

const icon = (itemAttrs: any): string => (itemAttrs.inputValue ? 'icon-check-square-fill' : 'icon-check-square-outline-empty');
const itemClass = (itemAttrs: any): string => (itemAttrs.inputValue ? 'primary--text v-list-item--active' : '');
const userName = (hook: AlertingHookDto): string | undefined => {
  const user = users.value.find((u) => u.email === hook.externalHook);
  return auth.getUser && auth.getUser.id === user?.id ? i18n.t('users.current_user_display', { user: user.name }) : user?.name;
};

const clear = () => {
  selectedMails.value = [];
  emit('input', selectedMails.value);
};

const putCurrentUserFirst = () => {
  const currentUserEmail = auth.getUser?.email;
  const currentUserIndex = mails.value.findIndex((mail) => mail.externalHook === currentUserEmail);
  if (currentUserIndex !== -1) {
    const hookIndex = mails.value.splice(currentUserIndex, 1)[0];
    mails.value.unshift(hookIndex);
  }
};

const fetchAllMailAlertingHooks = async () => {
  loading.value = true;
  const { data } = await AlertingHookService.getAllMailAlertingHooks();
  mails.value = data!;
  putCurrentUserFirst();
  loading.value = false;
};

const fetchAllUsers = async () => {
  const { data } = await UserService.getAllUsers({ });
  users.value = data!;
};

watch(() => searchString.value, () => {
  fetchAllMailAlertingHooks();
  fetchAllUsers();
});

return { __sfc: true,emit, auth, selectedMails, loading, mails, searchString, users, icon, itemClass, userName, clear, putCurrentUserFirst, fetchAllMailAlertingHooks, fetchAllUsers, _ref, __MACROS_useVModel, watch, getModule, store, authModule, AlertingHookService, AlertingHookDto, UserUiDto, UserService, i18n }
}

})